export const handleApiError = (e) => {
  if (e.response && e.response.data && e.response.data.message) {
    alert(e.response.data.message);
  } else {
    alert("Server not responding");
  }
};
